import { Controller } from '@hotwired/stimulus'
import { Turbo } from '@hotwired/turbo-rails'

/**
 * TurboRestoreController
 * ----------------------
 * Forces fresh page visits on browser back/forward navigation (popstate events).
 *
 * Problem: When using Turbo Drive with turbo_stream responses, the browser URL
 * updates but Turbo caches the original page snapshot. On restoration visits
 * (back/forward), Turbo shows the stale cached version instead of the
 * turbo_stream-updated content.
 *
 * Solution: Listen for popstate events and force Turbo.visit() with action: 'replace'
 * to fetch fresh content from the server.
 *
 * Usage: Add data-controller="turbo-restore" to the page container that uses
 * turbo_stream navigation.
 */
export default class extends Controller {
  connect() {
    this.handlePopstate = this.handlePopstate.bind(this)
    window.addEventListener('popstate', this.handlePopstate)
  }

  disconnect() {
    window.removeEventListener('popstate', this.handlePopstate)
  }

  handlePopstate(_event) {
    // On back/forward navigation, Turbo shows cached content which may be stale
    // when using turbo_stream responses. Force a fresh visit to get current state.
    Turbo.visit(window.location.href, { action: 'replace' })
  }
}
